import script from "./VNotificationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNotificationCard.vue?vue&type=script&setup=true&lang=ts"

import "./VNotificationCard.vue?vue&type=style&index=0&id=4019b181&lang=scss"

const __exports__ = script;

export default __exports__